import { render } from "./CreateWithAIView.vue?vue&type=template&id=1bc65c02&scoped=true"
import script from "./CreateWithAIView.vue?vue&type=script&lang=js"
export * from "./CreateWithAIView.vue?vue&type=script&lang=js"

import "./CreateWithAIView.vue?vue&type=style&index=0&id=1bc65c02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc65c02"]])

export default __exports__